
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/c/blog-posts/why-staar-ecrs-score-zero",
      function () {
        return require("private-next-pages/c/blog-posts/why-staar-ecrs-score-zero.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/c/blog-posts/why-staar-ecrs-score-zero"])
      });
    }
  